<span class="status-chip" [class]="'status-chip status-chip--' + variant">
  {{ label }}
</span>
